export default __webpack_public_path__ + "static/animation-0beb1a7061b3d9d4ad72b2e0f8397747.mp4";